import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";
//Import Context
import { AuthContext } from "../../contexts/AuthContext";
//Import Components
import PMEComplianceSummary from "../../ui-components/containers/reports/reportsPME/PMEComplianceSummary";
//Import Icons
import QuickAccess from "../../shared/ui-quickAccess/QuickAccess";

function HomeContent({ activeNotifications, getNotificationContent, handleNavigate }) {
    const { userData } = useContext(AuthContext);
    const navigate = useNavigate();
    return (
        <section className='home-container flex'>
            <section className='welcome-container flex'>
                <span className='flex'>
                    <h1>Bienvenido, {userData ? userData.displayName : 'Usuario'}</h1>
                    <p>{userData?.permissions === 'admin' ? 'Administrador' : userData?.department}</p>
                </span>
                <span className='date-container flex'>
                    <p className='day'>Hoy es {new Date().toLocaleDateString('es-ES', { weekday: 'long' })}</p>
                    <div className='date-box'>
                        <p className='date'>
                            <span className='day-number'>{new Date().getDate()}</span>
                            <span className='month-year'>{new Date().toLocaleDateString('es-ES', { month: 'long', year: 'numeric' })}</span>
                        </p>
                    </div>
                </span>
            </section>
            <span className='interactive-container flex'>
                <section className='activity-summary flex'>
                    <h2>Resumen de Actividades Recientes</h2>
                    <ul className='notification-popup active flex'>
                        {activeNotifications?.length > 0 ? (
                            userData?.dimension === 'Establecimiento' ? (
                                activeNotifications.map(notification => (
                                    <li key={notification.id} className='flex'>
                                        {notification && getNotificationContent(notification)}
                                    </li>
                                ))
                            ) : (
                                <li className='flex'>
                                    <p className='holder' onClick={handleNavigate}>
                                        Tienes <strong>{activeNotifications.length}</strong> solicitudes pendientes por responder.
                                    </p>
                                </li>
                            )
                        ) : (
                            <li>No hay actividades recientes.</li>
                        )}
                    </ul>
                </section>
                <span className='flex'>
                    <QuickAccess userData={userData} />
                    {(userData?.dimension === 'Sostenedor' || userData?.dimension === 'Establecimiento') && (
                        <section className='cumpliance-pme flex'>
                            <PMEComplianceSummary />
                        </section>
                    )}
                </span>
            </span>

        </section>
    );
};

export default HomeContent;